import styled from 'styled-components';
import AssignedUsers from '../AssignedUsers';
import UserSuggestions from '../UserSuggestions';

export const CustomAssignedUsers = styled(AssignedUsers)`
  margin-bottom: 32px;
  border-bottom: 1px solid;
  padding-bottom: 32px;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-right: 32px;
    border-right: 1px solid;
    border-bottom: 0;
    border-color: ${(props) => props.theme.colors['neutral-30']};
  }
`;

export const CustomUserSuggestions = styled(UserSuggestions)`
  border-color: ${(props) => props.theme.colors['neutral-30']};
  position: relative;
  left: -1px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border-left: 1px solid;
    padding-left: 32px;
    border-color: ${(props) => props.theme.colors['neutral-30']};
  }
`;

export const Container = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
  }
`;

export const SessionTitle = styled.p`
  margin-bottom: 24px;
  line-height: 16px;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const Divider = styled.div`
  width: 1px;
  height: 100%;
  background: red;
`;
